import {
  ImageObject,
  Organization,
  Person,
  PostalAddress,
  WithContext,
} from "schema-dts";

export const generateOrganizationSchema = (organization: {
  name: string;
  url?: string;
  logo?: ImageObject;
  address?: PostalAddress;
  telephone?: string;
  email?: string;
  foundingDate?: string;
  founder?: Person;
  sameAs?: string[];
  description?: string;
  keywords?: string[];
  legalName?: string;
}): WithContext<Organization> => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: organization.name,
    url: organization.url,
    logo: organization.logo,
    address: organization.address,
    telephone: organization.telephone,
    email: organization.email,
    foundingDate: organization.foundingDate,
    founder: organization.founder,
    sameAs: organization.sameAs,
    description: organization.description,
    keywords: organization.keywords,
    legalName: organization.legalName,
  };
};
